import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentLoadAuditsPage() {
  return <LatamAgentPage locale="pt-BR" agentKey="proactive_load_audits" />;
}
